import EditorField from "../../Utils/EditorField"
import { careerProfileLabels } from "../../Types/careerProfileLabels"
const CulturalBackground = ({ formik }) => {
  return (
    <>
      <h4
        style={{
          marginBottom: "2rem",
          color: "#383838",
          fontWeight: "400",
          fontSize: "14px",
          lineHeight: "19px",
        }}
      >
        Our agency aims to work with people from different backgrounds and with
        diverse experiences. The next set of questions will help me understand
        your background and culture, which may help us in planning for jobs.
      </h4>
      <EditorField
        value={formik.values.cultural_1}
        onTextChange={formik.setFieldValue}
        valueName={
          careerProfileLabels.culturalBackground.culturalBackground_1.value
        }
        label={
          careerProfileLabels.culturalBackground.culturalBackground_1.label
        }
        placeholder={
          careerProfileLabels.culturalBackground.culturalBackground_1.subLabel
        }
      />
      <div style={{ marginTop: "30px" }}>
        <EditorField
          value={formik.values.cultural_2}
          onTextChange={formik.setFieldValue}
          valueName={
            careerProfileLabels.culturalBackground.culturalBackground_2.value
          }
          label={
            careerProfileLabels.culturalBackground.culturalBackground_2.label
          }
        />
      </div>
      <div style={{ marginTop: "30px" }}>
        <EditorField
          value={formik.values.cultural_3}
          onTextChange={formik.setFieldValue}
          valueName={
            careerProfileLabels.culturalBackground.culturalBackground_3.value
          }
          label={
            careerProfileLabels.culturalBackground.culturalBackground_3.label
          }
        />
      </div>
      <div style={{ marginTop: "30px" }}>
        <EditorField
          value={formik.values.cultural_4}
          onTextChange={formik.setFieldValue}
          valueName={
            careerProfileLabels.culturalBackground.culturalBackground_4.value
          }
          label={
            careerProfileLabels.culturalBackground.culturalBackground_4.label
          }
        />
      </div>
      <div style={{ marginTop: "30px" }}>
        <EditorField
          value={formik.values.cultural_5}
          onTextChange={formik.setFieldValue}
          valueName={
            careerProfileLabels.culturalBackground.culturalBackground_5.value
          }
          label={
            careerProfileLabels.culturalBackground.culturalBackground_5.label
          }
        />
      </div>
    </>
  )
}
export default CulturalBackground
